import { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography } from "../../../../components";
import { Collapse, Divider, Skeleton } from "@mui/material";
import { MonitorFinanceiroService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const monitorFinanceiroService = new MonitorFinanceiroService();

const COR = "#1976d2";

function MonitorFinRankingDespesas({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [expandido, setExpandido] = useState({});

  useEffect(() => {
    buscar();
    setExpandido({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscar() {
    setLoading(true);
    const result =
      await monitorFinanceiroService.getDashboardRankingDespesas(filtrosBody);
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const maxValor = Math.max(...rows.map((r) => r.valor || 0), 0);

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Despesas Pagas no Período
          </Typography>
          <i
            className="ph-bold ph-list-bullets"
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Box>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={28}
                sx={{ mb: 1.5, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : rows.length === 0 ? (
          <Box display="flex" justifyContent="center" py={5}>
            <Typography variant="body2" color="text.secondary">
              Nenhuma despesa paga no período selecionado.
            </Typography>
          </Box>
        ) : (
          <Box>
            {rows.map((row, i) => {
              const pct = maxValor > 0 ? (row.valor / maxValor) * 100 : 0;
              const centros = row.centrosCusto || [];
              const aberto = !!expandido[i];
              return (
                <Box key={i} sx={{ mb: 1.75 }}>
                  <Box
                    onClick={() =>
                      centros.length > 0 &&
                      setExpandido((prev) => ({ ...prev, [i]: !prev[i] }))
                    }
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={0.5}
                    sx={{ cursor: centros.length > 0 ? "pointer" : "default" }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={0.5}
                      sx={{ maxWidth: "60%" }}
                    >
                      {centros.length > 0 && (
                        <i
                          className={`ph-bold ph-caret-${aberto ? "down" : "right"}`}
                          style={{ color: "#94a3b8", fontSize: 12 }}
                        />
                      )}
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#1e293b",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={row.categoria}
                      >
                        {row.categoria}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 700, color: "#1e293b" }}
                      >
                        {formatPrice(row.valor)}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.disabled",
                          minWidth: 40,
                          textAlign: "right",
                        }}
                      >
                        {(row.percentual || 0).toFixed(1)}%
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "#f1f5f9",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        width: `${pct}%`,
                        height: "100%",
                        borderRadius: 4,
                        backgroundColor: COR,
                        transition: "width 0.3s",
                      }}
                    />
                  </Box>
                  <Collapse in={aberto} timeout="auto" unmountOnExit>
                    <Box sx={{ pl: 2.5, pr: 0.5, pt: 1 }}>
                      {centros.map((c, j) => (
                        <Box
                          key={j}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ py: 0.3 }}
                        >
                          <Box display="flex" alignItems="center" gap={0.75}>
                            <Box
                              sx={{
                                width: 5,
                                height: 5,
                                borderRadius: "50%",
                                backgroundColor: "#cbd5e1",
                              }}
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.secondary",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: 170,
                              }}
                              title={c.centroCusto}
                            >
                              {c.centroCusto}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography
                              variant="caption"
                              sx={{ color: "#1e293b", fontWeight: 600 }}
                            >
                              {formatPrice(c.valor)}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.disabled",
                                minWidth: 40,
                                textAlign: "right",
                              }}
                            >
                              {(c.percentual || 0).toFixed(1)}%
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Collapse>
                </Box>
              );
            })}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default MonitorFinRankingDespesas;
